module.exports = __webpack_public_path__ + "img/Kerkira.2caac73c.png";